import { Component, OnInit, ElementRef } from '@angular/core';
import { MenuLeftV2Component } from '../menu-left/menu-left.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss'],
    imports: [MenuLeftV2Component, RouterOutlet, FooterComponent]
})

export class FullLayoutComponent {}